import { render, staticRenderFns } from "./StaySafe.vue?vue&type=template&id=1dbef870&scoped=true&"
import script from "./StaySafe.vue?vue&type=script&lang=js&"
export * from "./StaySafe.vue?vue&type=script&lang=js&"
import style0 from "./StaySafe.vue?vue&type=style&index=0&id=1dbef870&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbef870",
  null
  
)

export default component.exports